import { getFolderIdForTopBreadcrumb } from './breadcrumbsSelectors';
import { PROVIDER_ROOT_FOLDER_BREADCRUMB_ID } from '../constants';

export function getUserSelectedFolderIdForAction(): string | null {
    const topBreadcrumbFolderId = getFolderIdForTopBreadcrumb();

    // If the user has selected a folder then use that as selected folder
    // otherwise the current loaded folder should be considered the selected folder
    return topBreadcrumbFolderId;
}

export function getCurrentLoadedFolderId(): string | null {
    const topBreadcrumbFolderId = getFolderIdForTopBreadcrumb();
    if (topBreadcrumbFolderId) {
        const parentFolderId =
            topBreadcrumbFolderId === PROVIDER_ROOT_FOLDER_BREADCRUMB_ID
                ? undefined // If it's a root breadcrumb then set parent folder id to undefined so it will create in root folder
                : topBreadcrumbFolderId;

        return parentFolderId;
    }

    return null;
}
